import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getModules } from '../../core/api/endpoints/modules/modulesApi';
import { TachoModule } from '../../core/domainModels/modules/TachoModule';

export interface ModulesState {
    modules: Array<TachoModule>;
    fetchModulesPending: boolean;
    fetchModulesError: string;
    deleteModulePending: boolean;
    deleteModuleError: string;
    addModulePending: boolean;
    addModuleError: string;
    updateModulePending: boolean;
    updateModuleError: string;
}

const initialState: ModulesState = {
    modules: [],
    fetchModulesPending: false,
    fetchModulesError: '',
    deleteModulePending: false,
    deleteModuleError: '',
    addModulePending: false,
    addModuleError: '',
    updateModulePending: false,
    updateModuleError: '',
};

const name = 'modules';

const fetchModulesThunk = createAsyncThunk(`${name}/fetch`, async (params, thunkAPI) => {
    try {
        return await getModules();
    } catch (error) {
        return thunkAPI.rejectWithValue(error);
    }
});

const modulesSlice = createSlice({
    name,
    initialState,
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(fetchModulesThunk.pending, (state, action) => {
                state.fetchModulesPending = true;
                state.fetchModulesError = '';
            })
            .addCase(fetchModulesThunk.fulfilled, (state, action) => {
                state.fetchModulesError = '';
                state.modules = action.payload;
                state.fetchModulesPending = false;
            })
            .addCase(fetchModulesThunk.rejected, (state, action) => {
                state.fetchModulesPending = false;
                state.fetchModulesError = action.payload as string;
            });
    },
});

const { reducer } = modulesSlice;

export { reducer as modulesReducer };
export { fetchModulesThunk };
